const $ = jQuery.noConflict();

'use strict';
const Tabs = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domTabsBlockWrap: $('.js-tabs-block__wrap'),
	$domTabsBlockBox: $('.js-tabs-block__boxes'),
	$domTabsBlockBtn: $('.js-tabs-block__btn'),
	$domSwitchBlockWrap: $('.js-switch-block__wrap'),
	$domSwitchBlockBox: $('.js-switch-block__bottom'),
	$domSwitchBlockBtn: $('.js-switch-block__upper-box'),
	$domLinkBoxWrap: $('.js-slider-slide__box'),
	$domLinkBox: $('.slider-slide__box'),
	$domLinkEnd: $('.js-promo-listing-end'),
	classActive: 'is-active',
	classStop: 'stay',
	classFixed: 'fixed',

	/** @description Initialize */
	init: function() {
		this.tabsTabsBlock();
		this.tabsSwitchBlock();
		this.verticalTabs();
		this.goToSlideOnClick();
		if(window.innerWidth > 991) {
			this.scrollBox();
		}
		if(window.innerWidth > 1199) {
			this.cardsBoxesAutoplay();
		}
		const tabItem = $('.js-tabs-block__btn');
		if (tabItem) {
			if (tabItem.length >= 4) {
				tabItem.addClass('tabs-block__btn--lot');
			}
			if (tabItem.length === 2) {
				tabItem.addClass('tabs-block__btn--two');
			}
			if (tabItem.length === 3) {
				tabItem.addClass('tabs-block__btn--tree');
			}
		}

		if($('.tabs-block').length > 0 || $('.js-media-cont').length > 0) {
			$('.site-main').addClass('site-bg');
		}else {
			$('.site-main').removeClass('site-bg');
		}
	},

	tabsTabsBlock: function() {
		Tabs.$domTabsBlockBtn.on('click', function(e) {
			e.preventDefault();
			$(this).siblings(Tabs.$domTabsBlockBtn).removeClass(Tabs.classActive);
			$(this).addClass(Tabs.classActive);
			const index = $(this).index();
			$(this).parent().parent().parent().find(Tabs.$domTabsBlockBox).hide();
			$(this).parent().parent().parent().children().find(Tabs.$domTabsBlockBox).eq(index).fadeIn('slow');
			if (window.innerWidth < 768) {
				$('html, body').animate({
					scrollTop: Tabs.$domTabsBlockWrap.offset().top -150
				}, 1000);
			}
		});
	},

	tabsSwitchBlock: function() {
		Tabs.$domSwitchBlockBtn.on('click', function(e) {
			e.preventDefault();
			$(this).siblings(Tabs.$domSwitchBlockBtn).removeClass(Tabs.classActive);
			$(this).addClass(Tabs.classActive);
			const index = $(this).index();
			$(this).parent().parent().parent().parent().parent().find(Tabs.$domSwitchBlockBox).hide();
			$(this).parent().parent().parent().parent().parent().children().find(Tabs.$domSwitchBlockBox).eq(index).fadeIn('slow');
			if (window.innerWidth < 768) {
				$('html, body').animate({
					scrollTop: Tabs.$domSwitchBlockWrap.offset().top + 400
				}, 1000);
			}
		});
	},

	verticalTabs() {
		$('.slider-side__tab').parent().removeClass('js-active-tab');
		$('.slider-side__tab').parent().first().addClass('js-active-tab');
		$('.slider-side__tab').on('click', function(evt) {
			evt.preventDefault();
			$(this).toggleClass('active');
			$(this).parent().addClass('js-active-tab');
			$(this).parent().siblings().find('.slider-side__tab.active').removeClass('active');
			$(this).parent().siblings().removeClass('js-active-tab');
			const sel = this.getAttribute('data-toggle-target');
			$('.slider-side__image').removeClass('active').filter(sel).addClass('active');
		});

		// make the tabs autoplay
		const $tabs = $('.slider-side__tab');
		let currentTab = 1;
		const timer = setInterval(function() {
			$tabs.eq(currentTab).toggleClass('active');
			$tabs.eq(currentTab).parent().addClass('js-active-tab');
			$tabs.eq(currentTab).parent().siblings().find('.slider-side__tab.active').removeClass('active');
			$tabs.eq(currentTab).parent().siblings().removeClass('js-active-tab');
			const sel = $tabs.eq(currentTab).attr('data-toggle-target');
			$('.slider-side__image').removeClass('active').filter(sel).addClass('active');
			currentTab = ++currentTab % $tabs.length;
		}, 2500);
		// Stop the aoutoplay when tab is clicked
		$tabs.on('click', function() {
			clearInterval(timer);
		});
	},

	cardsBoxesAutoplay: function() {
		const $tabs = $('.cards-block-col .cards-block__box');
		let currentTab = 0;
		const timer = setInterval(function() {
			$tabs.eq(currentTab).toggleClass('is-active-animation');
			$tabs.eq(currentTab).parent().siblings().find('.cards-block__box').removeClass('is-active-animation');
			currentTab = ++currentTab % $tabs.length;
		}, 1500);
		$('.cards-block__wrap').on('mouseenter', function() {
			clearInterval(timer);
			$tabs.eq(currentTab).removeClass('is-active-animation');
			$('.cards-block-col .cards-block__box').removeClass('is-active-animation');
		});
	},

	scrollBox: ()=> {
		if ($(Tabs.$domLinkBox).length > 0) {
			const stickyTop = $(Tabs.$domLinkBox).offset().top;

			$(window).on('scroll', function() {
				const windowTop = $(window).scrollTop();

				if (stickyTop < (windowTop) + 150) {
					$(Tabs.$domLinkBox).addClass(Tabs.classFixed);
				} else {
					$(Tabs.$domLinkBox).removeClass(Tabs.classFixed);
					$(Tabs.$domLinkBox).removeClass(Tabs.classStop);
				}
				if (window.innerWidth > 991) {
					if ($(Tabs.$domLinkEnd).offset().top < $(window).scrollTop() + (Tabs.$domLinkEnd.offset().top) - Tabs.$domLinkEnd.innerHeight() - stickyTop - 100) {
						$(Tabs.$domLinkBox).removeClass(Tabs.classFixed);
						$(Tabs.$domLinkBox).addClass(Tabs.classStop);
					} else if (stickyTop < (windowTop)) {
						$(Tabs.$domLinkBox).addClass(Tabs.classFixed);
						$(Tabs.$domLinkBox).removeClass(Tabs.classStop);
					}
				} else {
					if ($(Tabs.$domLinkEnd).offset().top < $(window).scrollTop() + (Tabs.$domLinkEnd.offset().top) - Tabs.$domLinkEnd.innerHeight() - stickyTop - 200) {
						$(Tabs.$domLinkBox).removeClass(Tabs.classFixed);
						$(Tabs.$domLinkBox).addClass(Tabs.classStop);
					} else if (stickyTop < (windowTop)) {
						$(Tabs.$domLinkBox).addClass(Tabs.classFixed);
						$(Tabs.$domLinkBox).removeClass(Tabs.classStop);
					}
				}
			});
		}
	},

	goToSlideOnClick: function() {
		$('.js-slider-side-navigation .slick-slide').on('click', function(e) {
			e.preventDefault();
			if (window.innerWidth < 992) {
				$('html, body').animate({
					scrollTop: Tabs.$domLinkBoxWrap.offset().top - 200
				}, 1000);
			}
		});
	}
};

export default Tabs;
